const determineOrgInfo = ({ organization }) => {
  const members = organization?.members || [];

  const paidMembers = members.filter((member) => member?.user?.professional?.type !== "BOOKKEEPER");

  return {
    allMembersCount: organization?.members?.length || 0,
    paidMembersCount: paidMembers.length,
    // At present, this means that the organization has a bookkeeper.
    freeMembersCount: members.length - paidMembers.length,
  };
};

export default determineOrgInfo;
